import { Card } from "../components/ui/card";

export function ComingSoon({ title, subtitle, testId }) {
  return (
    <div className="space-y-6 animate-in" data-testid={testId}>
      <div>
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Module</div>
        <h1 className="font-serif-display text-3xl">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      <Card className="border-dashed p-10 text-center text-muted-foreground">
        <div className="text-[11px] uppercase tracking-widest">Phase 2 module</div>
        <p className="mt-2 max-w-md mx-auto text-sm">This module is available with the core CRM and will be built out further in the next iteration. Data captured elsewhere flows into this view automatically.</p>
      </Card>
    </div>
  );
}

export const Marketing = () => <ComingSoon title="Marketing Campaigns" subtitle="Campaign hierarchy, spend, and ROI (excluding deal values) — coming next." testId="page-marketing"/>;
export const Approvals = () => <ComingSoon title="Approvals Inbox" subtitle="Booking, transfer and discount approvals — coming next." testId="page-approvals"/>;
export const Tasks = () => <ComingSoon title="Tasks" subtitle="Task list per user and record — coming next." testId="page-tasks"/>;
